import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const AuthContext = createContext({
  user: null,
  loading: true,
  loginWithToken: () => {},
  logout: () => {},
  refresh: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('concorde_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const r = await api.get('/auth/me');
      setUser(r.data.user);
    } catch (e) {
      localStorage.removeItem('concorde_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const loginWithToken = (token, u) => {
    localStorage.setItem('concorde_token', token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem('concorde_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginWithToken, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
